function ___$insertStyle(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var anime = require('animejs');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var anime__default = /*#__PURE__*/_interopDefaultLegacy(anime);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
}; // Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).


var getRandomValues;
var rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */


var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0; // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434

  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
} // Need to use a forwardRef, obtaining a ref from the parent to allow the use of controls.


var Anime = React.forwardRef(function (props, ref) {
  if (typeof window === 'undefined') {
    return React__default['default'].createElement("div", {
      className: props.className,
      style: props.style
    });
  }

  var animeInstance = React.useRef(anime__default['default']({}));
  var uuid = v4();
  React.useEffect(function () {
    // Cleanup any other wandering anime tags.
    anime__default['default'].remove(".__anime__" + uuid);
    var myAnimeInstance = anime__default['default'](_assign({
      targets: document.querySelectorAll(".__anime__" + uuid)
    }, props.config));
    animeInstance.current = myAnimeInstance;
  }, [props, props.config, props.children]); // Setup controls here, the user can access these if they use a ref.

  React.useImperativeHandle(ref, function () {
    return {
      restart: function restart() {
        animeInstance.current.restart();
      },
      play: function play() {
        animeInstance.current.play();
      },
      pause: function pause() {
        animeInstance.current.pause();
      },
      reverse: function reverse() {
        animeInstance.current.reverse();
      },
      seek: function seek(timeStamp) {
        animeInstance.current.seek(timeStamp);
      },
      seekPercent: function seekPercent(scrollPercent) {
        animeInstance.current.seek(scrollPercent / 100 * animeInstance.current.duration);
      }
    };
  }); // Ensure that props.children is always an array so .map works.

  var childArray = Array.isArray(props.children) ? props.children : [props.children]; // Attach __anime__id to each child so Anime.js can track and manipulate the elements.
  // Note that it is important that every child has a unique key prop or else hotloading will produce strange behaviour.

  var styleChildren = function styleChildren(children) {
    return React__default['default'].Children.map(children, function (child, key) {
      var _a;

      return React__default['default'].cloneElement(child, {
        className: ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.className) + " __anime__" + uuid,
        key: "__anime__" + uuid + "__" + key
      });
    });
  };

  return (// This outer <div></div> appears as <Anime></Anime> to the user.
    React__default['default'].createElement("div", {
      style: _assign({}, props.style),
      className: "" + props.className
    }, styleChildren(childArray))
  );
});
Object.defineProperty(exports, 'anime', {
  enumerable: true,
  get: function get() {
    return anime__default['default'];
  }
});
exports.default = Anime;